import {
  calculatorEligibleDesktop,
  calculatorLandingDesktop,
  calculatorNotEligibleDesktop,
  commercialEligibilityDesktop,
  commercialEligibilityMobile,
  commercialSuccessDesktop,
  commercialSuccessMobile,
  congratsDesktop,
  congratsManDesktop,
  congratsManMobile,
  congratsMobile,
  doorDesktop,
  estimatedCostsSuccessDesktop,
  estimatedCostsSuccessMobile,
  getApprovedDesktop,
  getApprovedMobile,
  ImageData,
  pairDesktop,
} from './image-list';

export interface ABTestImageMeta {
  control: ImageData;
  variation?: ImageData;
}

export interface ABTestImageRegistry {
  [imageOutlet: string]: ABTestImageMeta;
}

export enum Resolution {
  mobile = 'Mobile',
  tablet = 'Tablet',
  desktop = 'Desktop',
}

export const imageRegistry: ABTestImageRegistry = {
  // Prequalification
  eligibilityMobile: { control: getApprovedMobile },
  eligibilityDesktop: { control: getApprovedDesktop },

  // Commercial Prequalification
  commercialEligibilityMobile: { control: commercialEligibilityMobile },
  commercialEligibilityDesktop: { control: commercialEligibilityDesktop },

  // Eligibility Success
  eligibilitySuccessMobile: { control: congratsManMobile },
  eligibilitySuccessDesktop: { control: congratsManDesktop },

  // Commercial Eligibility Success
  commercialSuccessMobile: { control: commercialSuccessMobile },
  commercialSuccessDesktop: { control: commercialSuccessDesktop },

  // Secure Site
  secureSiteMobile: { control: pairDesktop },
  secureSiteDesktop: { control: pairDesktop },
  secureSiteLoginMobile: { control: doorDesktop },
  secureSiteLoginDesktop: { control: doorDesktop },
  // Secure Site Upload Success
  // NOTE: Although names are different but using it in Secure Site Uploader.
  applicationSuccessMobile: { control: congratsMobile },
  applicationSuccessDesktop: { control: congratsDesktop },

  // Calculator
  calculatorLandingDesktop: { control: calculatorLandingDesktop },
  calculatorEligibleDesktop: { control: calculatorEligibleDesktop },
  calculatorNotEligibleDesktop: { control: calculatorNotEligibleDesktop },

  //prequal Calculator
  estimatedCostsSuccessDesktop: { control: estimatedCostsSuccessDesktop },
  estimatedCostsSuccessMobile: { control: estimatedCostsSuccessMobile },
};
